import { Component, Input, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RichEditorComponent } from 'src/app/shared/components/rich-editor/rich-editor';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

export interface RichEditorDialogData {
    title: string;
    description: string;
    maxLength: number;
}

@Component({
    selector: 'nova-rich-editor-dialog-component',
    templateUrl: './rich-editor-dialog-component.html',
    styleUrls: ['./rich-editor-dialog-component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatIconModule, RichEditorComponent, MatDialogModule, MatLegacyButtonModule]
})
export class RichEditorDialogComponent implements OnInit {
    @Input() title = '';
    @Input() note: string;
    @Input() maxLength: number = null;

    description: UntypedFormControl;

    constructor(@Inject(MAT_DIALOG_DATA) private readonly _data: RichEditorDialogData) {}

    ngOnInit(): void {
        this.maxLength = this._data && 'maxLength' in this._data ? this._data.maxLength : 1500;
        this.description = new UntypedFormControl('', [Validators.maxLength(this.maxLength)]);
        this.title = this._data.title;
        this.description.setValue(this._data.description ?? this.note);
    }

    isSaveDisabled(): boolean {
        return !this.description.valid;
    }

    getResult(cancelled = false): unknown {
        if (cancelled) {
            return null;
        }

        return this.description.value;
    }
}
